import localforage from 'myStore'

import actions from './actions'

const STORED_SETTINGS = async (storedSettings) => {
  const settings = {}
  // Object.keys(storedSettings).forEach((key) => {
  const keys = Object.keys(storedSettings)
  for (const key of keys) {
    if (key === 'isMenuCollapsed') {
      settings[key] = true
    } else {
      const item = await localforage.getItem(`app.settings.${key}`)
      settings[key] = item != null ? item : storedSettings[key]
    }
  }
  return settings
}

const initialState = {
  ...(await STORED_SETTINGS({
    authProvider: 'jwt', // firebase, jwt
    logo: '',
    locale: 'ko-KR',
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: true,
    menuLayoutType: 'left', // left, top, nomenu
    routerAnimation: 'zoom-fadein', // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
    menuColor: 'white', // white, dark, gray
    theme: 'default', // default, light, dark
    authPagesColor: 'white', // white, gray, image
    primaryColor: '#4b7cf3',
    leftMenuWidth: 256,
    isMenuUnfixed: false,
    isMenuShadow: false,
    isTopbarFixed: false,
    isGrayTopbar: true,
    isContentMaxWidth: true,
    isAppMaxWidth: true,
    isGrayBackground: true,
    isCardShadow: true,
    isSquaredBorders: false,
    isBorderless: false,
  })),
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
